module.exports = __webpack_public_path__ + "img/ashp.f616de15.png";